export enum SessionState {
	INITIAL = 'INITIAL',
	USER_PENDING = 'USER_PENDING',
	USER_MISSING = 'USER_MISSING',
	VALID = 'VALID'
}
